import Glide from '@glidejs/glide';

if (document.querySelectorAll('#product .glide__slide').length > 3) {
  const glide = new Glide('.glide', {
    type: 'carousel',
    startAt: 0,
    perView: 1
  });

  glide.mount();

  // Thumbnails
  document.querySelectorAll('.thumbnails .thumb').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      glide.go(`=${thumb.getAttribute('data-slide-id')}`);
    });
  });
}